/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useRef } from "react";
import PageTitle from "../../components/Common/MetaTagsHelper/metaTagsHelper";
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import usePageTitle from '../../common/hooks/usePageTitle';

import { getNameClient } from '../../helpers/nameClient';
import {
    Row,
    Col,
    Card,
    CardBody,
    Container,
    TabContent,
    TabPane,
    NavItem,
    NavLink,
    Progress,
    Spinner
} from "reactstrap";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import IButtonComponent from "../../components/Common/iComponents/iButton/IButton";
import { GetMilestonesEventsNameSH } from '../../store/shipments/actions';
import { getMilestonesLifeEvents, addMilestonesLifeEvents } from '../../store/milestones/actions';
import Swal from 'sweetalert2';
import './index.scss';

const MilestonesTrackingConfig = (props: any) => {
    const PageTitleIEN = usePageTitle(props.location.pathname);
    const dispatch = useDispatch();
    const { milestoneEventSH, isLoading } = useSelector((state: any) => state.shipments);
    const { MilestonesLifeEvents, isLoadingLifeEventsAdd, success } = useSelector((state: any) => state.Milestones);
    const tabs = [
        {
            icon: "bx bx-book-content",
            name: "Select Events",
            description: "Select the events to be displayed"
        },
        {
            icon: "bx bx-selection",
            name: "Set Order",
            description: "Drag to achieve the desired order"
        },
        {
            icon: "bx bx-check",
            name: "Preview",
            description: "This is how milestones will appear in the milestones section of your shipments."
        }
    ]

    useEffect(() => {
        dispatch(GetMilestonesEventsNameSH());
        dispatch(getMilestonesLifeEvents());
    }, [])

    useEffect(() => {
        setState({
            ...state,
            milestoneEventSH: milestoneEventSH
        })
    }, [milestoneEventSH])

    useEffect(() => {
        const filterString = new Set(MilestonesLifeEvents.map((item: any) => `${item.name.toUpperCase()}`));
        const newArray = milestoneEventSH.filter((item: any) => {
            const setString = `${item.name.toUpperCase()}`;
            return !filterString.has(setString);
        });
        setState({
            ...state,
            milestoneEventSH: newArray,
            selectedEvents: MilestonesLifeEvents,
        })
    }, [milestoneEventSH, MilestonesLifeEvents])



    const [state, setState] = useState<any>({
        activeTabProgress: 0,
        progressValue: 100 / tabs.length * 1,
        milestoneEventSH: [],
        selectedEvents: []
    });

    const toggleTabProgress = (tab: any) => {
        if (tab >= 0 && tab < tabs.length) {
            setState({
                ...state,
                activeTabProgress: tab,
                progressValue: 100 / tabs.length * (tab + 1),
            });
        }

    }

    const addSelectedEvent = (item: any) => {
        let newArray = state.selectedEvents.reverse();
        newArray.push({ ...item });
        const newSecondArray = state.milestoneEventSH.filter((itemFilter: any) => itemFilter.name !== item.name)
        newArray = newArray.map((item: any, index: any) => {
            return { ...item, order: index }
        })
        setState({
            ...state,
            selectedEvents: newArray,
            milestoneEventSH: newSecondArray
        });
    };

    const RemoveSelectedEvent = (item: any) => {
        const newArray = state.milestoneEventSH.reverse();
        newArray.push(item);
        const newSecondArray = state.selectedEvents.filter((itemFilter: any) => itemFilter.name !== item.name)
        setState({
            ...state,
            milestoneEventSH: newArray,
            selectedEvents: newSecondArray
        });
    };

    const handleSortEnd = () => {
        const newArray = [...state.selectedEvents]
        const tempArray = newArray[dragEvent.current]
        newArray[dragEvent.current] = newArray[draggedOverEvent.current]
        newArray[draggedOverEvent.current] = tempArray
        setState({ ...state, selectedEvents: newArray })
    }

    const saveOrderOnDb = () => {
        const getAuthUser = localStorage.getItem('authUser');
        let user: any;
        let newState;
        if (getAuthUser) {
            user = JSON.parse(getAuthUser);
            newState = state.selectedEvents.map((item: any, index: any) => {
                return {
                    ...item,
                    clientId: user.EMPRESA_ID,
                    order: index
                }
            })
            dispatch(addMilestonesLifeEvents(newState));
            if (isLoadingLifeEventsAdd) {
                Swal.showLoading()
            } else {
                Swal.fire(
                    success == "true" || success == "" ? {
                        text: 'New items have been added successfully!!!',
                        icon: 'success',
                    } : {
                        text: success,
                        icon: 'error'
                    }
                );
            }
        }
    }

    const dragEvent = useRef<number>(0)
    const draggedOverEvent = useRef<number>(0)

    return (
        <React.Fragment>
            <div className="page-content">
                <PageTitle>
                    <title>Milestones Tracking Config | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>
                    {/* <Breadcrumbs title="Milestones Tracking Config" breadcrumbItem={PageTitleIEN.replace(/-/g, ' ') === "" ? "Milestones Tracking Config" : PageTitleIEN.replace(/-/g, ' ')} /> */}
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    {
                                        state.milestoneEventSH.length === 0  && state.selectedEvents.length === 0 ?
                                            <>
                                                <i style={{ color: "red" }} className=' bx-flashing text-center d-flex justify-content-center eventIcon color-red bx bxs-message-alt-error' ></i>
                                                <div className="text-center d-flex justify-content-center">
                                                    No shipments were found, therefore there are no events to display. Please add shipments.
                                                </div>
                                            </>
                                            :
                                            <div id="progrss-wizard" className="twitter-bs-wizard">
                                                <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                                                    {
                                                        tabs.map((item, index) => {
                                                            return (
                                                                <NavItem key={index}>
                                                                    <NavLink
                                                                        className={classnames("nav-link ", {
                                                                            active: state.activeTabProgress === index,
                                                                        })}
                                                                        onClick={() => {
                                                                            setState({
                                                                                ...state,
                                                                                activeTabProgress: index,
                                                                                progressValue: 100 / tabs.length * (index + 1),

                                                                            });
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="step-icon"
                                                                            data-bs-toggle="tooltip"
                                                                            data-bs-placement="top"
                                                                            title="Seller Details"
                                                                        >
                                                                            <i className={item.icon}></i>
                                                                        </div>
                                                                    </NavLink>
                                                                </NavItem>
                                                            )
                                                        })
                                                    }
                                                </ul>

                                                <div id="bar" className="mt-4">
                                                    <Progress
                                                        color="success"
                                                        striped
                                                        animated
                                                        value={state.progressValue}
                                                    />
                                                </div>
                                                <TabContent
                                                    activeTab={state.activeTabProgress}
                                                    className="twitter-bs-wizard-tab-content"
                                                >
                                                    <TabPane tabId={0}>
                                                        <div className="text-center mb-4">
                                                            <h5>{tabs[0].name}</h5>
                                                            <p className="card-title-desc">
                                                                {tabs[0].description}
                                                            </p>
                                                        </div>
                                                        {
                                                            isLoading ? <div className="d-flex justify-content-center align-items-center pt-5"><Spinner></Spinner></div>
                                                                :
                                                                <Row className="d-flex align-items-center justify-content-center">
                                                                    <Col sm={5} className="pe-4">
                                                                        {
                                                                            state.milestoneEventSH?.map((item: any, index: any) => {
                                                                                return (
                                                                                    <div key={index} >
                                                                                        <Row className="eventRow">
                                                                                            <Col sm={9} className=" eventRowName d-flex justify-content-center align-items-center">
                                                                                                <h4 className="fs-6 text-center">{item.name}</h4>
                                                                                            </Col>
                                                                                            <Col
                                                                                                sm={3}
                                                                                                className=" eventRowOnClick bx-fade-right-hover"
                                                                                                onClick={() => addSelectedEvent(item)}
                                                                                            >
                                                                                                <i className=' text-center d-flex justify-content-center eventIcon bx bxs-chevrons-right' ></i>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        }
                                                                    </Col>
                                                                    <Col sm={5}>
                                                                        {
                                                                            state.selectedEvents.map((item: any, index: any) => {
                                                                                return (
                                                                                    <div key={index} >
                                                                                        <Row className="eventRow">
                                                                                            <Col
                                                                                                sm={3}
                                                                                                className=" eventRowOnClickRight bx-fade-left-hover"
                                                                                                onClick={() => RemoveSelectedEvent(item)}
                                                                                            >
                                                                                                <i className=' text-center d-flex justify-content-center eventIcon bx bxs-chevrons-left' ></i>
                                                                                            </Col>
                                                                                            <Col sm={9} className=" eventRowName d-flex justify-content-center align-items-center">
                                                                                                <h4 className="fs-6 text-center">{item.name}</h4>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                        }
                                                    </TabPane>
                                                    <TabPane tabId={1}>
                                                        <div>
                                                            <div className="text-center mb-4">
                                                                <h5>{tabs[1].name}</h5>
                                                                <p className="card-title-desc">
                                                                    {state.selectedEvents.length !== 0 ? tabs[1].description : "No Selected Events"}
                                                                </p>
                                                            </div>
                                                            {
                                                                state.selectedEvents.length !== 0 ?
                                                                    <Row className="d-flex align-items-center justify-content-center">
                                                                        <Col sm={5}>
                                                                            {
                                                                                state.selectedEvents.map((item: any, index: any) => {
                                                                                    return (
                                                                                        <div key={index}
                                                                                            draggable
                                                                                            onDragStart={() => dragEvent.current = index}
                                                                                            onDragEnter={() => draggedOverEvent.current = index}
                                                                                            onDragEnd={handleSortEnd}
                                                                                            onDragOver={(e) => e.preventDefault()}
                                                                                        >
                                                                                            <Row className="eventRowGrap">
                                                                                                <Col
                                                                                                    sm={3}
                                                                                                    className="eventRowOnClickGrap bx"
                                                                                                    onClick={() => RemoveSelectedEvent(item)}
                                                                                                >
                                                                                                    <i className=' text-center d-flex justify-content-center eventIconGrap bx bx-menu' ></i>
                                                                                                </Col>
                                                                                                <Col sm={9} className=" eventRowName d-flex justify-content-center align-items-center">
                                                                                                    <h4 className="fs-6 text-center">{item.name}</h4>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </Col>
                                                                    </Row> : <></>
                                                            }
                                                        </div>
                                                    </TabPane>
                                                    <TabPane tabId={2}>
                                                        <div>
                                                            <div className="text-center mb-4">
                                                                <h5>{tabs[2].name}</h5>
                                                                <p className="card-title-desc">
                                                                    {state.selectedEvents.length !== 0 ? tabs[2].description : "No Selected Events"}
                                                                </p>
                                                            </div>
                                                            {
                                                                state.selectedEvents.length !== 0 ?
                                                                    <Container className="container">
                                                                        <Row>
                                                                            <Col>
                                                                                <div className="timeline-steps" >
                                                                                    {state.selectedEvents.map((event: any, index: any) => (
                                                                                        <div className="timeline-step" key={index}>
                                                                                            <div className="timeline-content">

                                                                                                {index > (state.selectedEvents.length / 2) ? (
                                                                                                    <div className="inner-circle"></div>
                                                                                                ) :
                                                                                                    <div className="inner-circle2">
                                                                                                        <div className="position-absolute"><i className='eventIconCheck bx bx-check' ></i></div>
                                                                                                    </div>
                                                                                                }
                                                                                                <p className="h6 text-muted mb-0 mb-lg-0">{event.name}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </Container> : <></>
                                                            }
                                                        </div>
                                                    </TabPane>
                                                </TabContent>
                                                <ul className="pager wizard twitter-bs-wizard-pager-link">
                                                    {
                                                        state.activeTabProgress !== 0 ?
                                                            <li
                                                                className={
                                                                    state.activeTabProgress === 1
                                                                        ? "previous disabled"
                                                                        : "previous"
                                                                }
                                                            >
                                                                <IButtonComponent
                                                                    label={'Previous'}
                                                                    btnIcon="bx bx-chevron-left"
                                                                    className="btn btn-primary"
                                                                    actionOnClick={() => {
                                                                        toggleTabProgress(
                                                                            state.activeTabProgress - 1
                                                                        );
                                                                    }}
                                                                >
                                                                </IButtonComponent>
                                                            </li> : <></>
                                                    }
                                                    {
                                                        state.selectedEvents.length !== 0 ?
                                                            (
                                                                state.activeTabProgress !== (tabs.length - 1) ?
                                                                    <li
                                                                        className={
                                                                            state.activeTabProgress === 3
                                                                                ? "next disabled"
                                                                                : "next"
                                                                        }
                                                                    >
                                                                        <IButtonComponent
                                                                            iconPlace={'Right'}
                                                                            label={'Next'}
                                                                            btnIcon="bx bx-chevron-right"
                                                                            className="btn btn-primary"
                                                                            actionOnClick={() => {
                                                                                toggleTabProgress(
                                                                                    state.activeTabProgress + 1
                                                                                );
                                                                            }}
                                                                        >
                                                                        </IButtonComponent>
                                                                    </li> : (
                                                                        state.selectedEvents.length !== 0 ?
                                                                            <li
                                                                                className={
                                                                                    state.activeTabProgress === 3
                                                                                        ? "next disabled"
                                                                                        : "next"
                                                                                }
                                                                            >
                                                                                <IButtonComponent
                                                                                    disable={state.selectedEvents.length === 0}
                                                                                    iconPlace={'Right'}
                                                                                    label={'Save'}
                                                                                    btnIcon="bx bx-save"
                                                                                    className="btn btn-primary"
                                                                                    actionOnClick={saveOrderOnDb}
                                                                                >
                                                                                </IButtonComponent>
                                                                            </li> : <></>
                                                                    )
                                                            ) : <></>
                                                    }
                                                </ul>
                                            </div>}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default MilestonesTrackingConfig;